<div class="mat-elevation-z8 vendor-container">
    <div class="header-actions">
        <h1>Vendors</h1>
        <div class="action-buttons">
            <button mat-raised-button color="primary" (click)="openVendorForm()">
                <mat-icon>add</mat-icon> Add Vendor </button>
            <button mat-raised-button color="accent" (click)="importFileInput.click()">
                <mat-icon>upload</mat-icon> Import CSV </button>
            <input #importFileInput type="file" hidden accept=".csv" (change)="onFileSelected($event)">
            <button mat-raised-button color="basic" (click)="downloadExampleCsv()">
                <mat-icon>download</mat-icon> Download Example CSV
            </button>
        </div>
    </div>
    <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search vendors..." #input>
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
    </div>
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let vendor"> {{vendor.name.en || vendor.name.fr}} </td>
            </ng-container>
            <!-- Shops Count Column -->
            <ng-container matColumnDef="shops">
                <th mat-header-cell *matHeaderCellDef>Shops</th>
                <td mat-cell *matCellDef="let vendor"> {{vendor.shops?.length || 0}} </td>
            </ng-container>
            <!-- Status Column -->
            <ng-container matColumnDef="deleted">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let vendor">
                    <mat-chip-list>
                        <mat-chip [color]="vendor.deleted ? 'warn' : 'primary'" selected> {{vendor.deleted ? 'Deleted' :
                            'Active'}} </mat-chip>
                    </mat-chip-list>
                </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let vendor">
                    <button mat-icon-button color="primary" (click)="openVendorForm(vendor)" matTooltip="Edit">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="deleteVendor(vendor._id)" matTooltip="Delete">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
            </tr>
        </table>
    </div>
</div>